import { CaretDownOutlined } from '@ant-design/icons';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dropdown, Space } from 'antd';

import { useContentWidth } from '@app/hooks';

import { useSalePlansPageHeader } from '@pages/SalePlans/hooks';

import type { MenuProps } from 'antd';

export const SalePlansHeader = () => {
  const {
    hasUserRightToExportSalePlans,
    downloadFileHandler,
    isLoading,
    linkContainerRef,
  } = useSalePlansPageHeader();
  const { contentWidth } = useContentWidth();

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div onClick={downloadFileHandler} data-testid="export-to-excel">
          Выгрузить в Excel
        </div>
      ),
    },
  ];

  return (
    <>
      {hasUserRightToExportSalePlans && (
        <>
          {contentWidth > 365 ? (
            <Dropdown menu={{ items }} placement="bottomRight">
              <Button loading={isLoading} data-testid="excel-operations">
                <Space>
                  <span>Операции с Excel</span>
                  <CaretDownOutlined />
                </Space>
              </Button>
            </Dropdown>
          ) : (
            <Dropdown menu={{ items }} placement="bottomRight">
              <Button loading={isLoading}>
                <FontAwesomeIcon icon={faFileExcel} size={'lg'} />
              </Button>
            </Dropdown>
          )}
          <div ref={linkContainerRef} />
        </>
      )}
    </>
  );
};
